import script from "./AdminHealthSafetyDashboardView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminHealthSafetyDashboardView.vue?vue&type=script&setup=true&lang=js"

import "./AdminHealthSafetyDashboardView.vue?vue&type=style&index=0&id=66abc0ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66abc0ae"]])

export default __exports__